export const getShareURL = (path: string, locale: string) => {
  let baseUrl = `https://jobs.acerta.be/${locale}`;
  const sharingURL = `${baseUrl}${path}`;
  return sharingURL;
};

export const getShareURLNl = (path: string) => {
  let baseUrl = "https://jobs.acerta.be/fr-FR";
  const sharingURL = `${baseUrl}${path}`;
  return sharingURL;
};

export const getShareURLFr = (path: string) => {
  let baseUrl = "https://jobs.acerta.be/nl";
  const sharingURL = `${baseUrl}${path}`;
  return sharingURL;
};
